import apiV2 from '.'

export const gptApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    generateCss: builder.mutation({
      query: ({ selector, currentCss, instruction, outerHTML }) => ({
        url: '/gpt/generate-css',
        method: 'POST',
        body: { selector, currentCss, instruction, outerHTML },
      }),
      transformResponse: response => response.data,
    }),
  }),
})

export const { useGenerateCssMutation } = gptApi
